var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transfer-history-list"},[_c('h2',{staticClass:"transfer-history-list__title"},[_vm._v("История переводов")]),_c('div',{staticClass:"transfer-history-list__wrapper"},_vm._l((_vm.transfers),function(transfer){return _c('transfer-history-item',{key:transfer.id,attrs:{"transfer":transfer}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }